<template>
  <BikeSetup
    v-if="bikeData && bikeSetup"
    :hide-delta="true"
    :hide-stack-reach="true"
    :bike-category="
      getBikeCategory(bikeData?.MAIN_BIKETYPE_NAME, bikeData?.SUB_BIKETYPE_NAME)
    "
    :crank-arm-length="bikeData?.CRANK_LENGTH"
    :pedal-height="bikeData?.PEDAL_HEIGHT"
    :saddle-handlebar-drop="bikeSetup?.SADDLE_HANDLEBAR_DROP"
    :saddle-height="bikeSetup?.SADDLE_HEIGHT"
    :saddle-to-handlebar="bikeSetup?.SADDLE_HANDLEBAR_DISTANCE"
    :saddle-width="80"
  />
  <BfLoader v-else />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { getBikeCategory } from '@/utils/utils'
import BikeSetup from '@/components/preview/common/BikeSetup.vue'
import { BfLoader } from '@finetic/bikefitting-ui'

const bikeStore = useBikeStore()
const { bikeData, bikeSetup } = storeToRefs(bikeStore)
</script>

<style lang="scss"></style>
